export default "__VITE_ASSET__BWjLrkDc__";